import { FC, useEffect, useMemo } from 'react';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import PointBasicForm from 'components/Forms/PointBasicForm/PointBasicForm';
import { AppLoader } from 'components/Core/AppLoader';
import { pointTranslations } from './translations';
import { PointTransFields } from './types';
import styles from './point.module.scss';
import { EntityTitle } from 'components/Core/EntityTitle';

const Point: FC = observer(() => {
  const {
    pointsStore: { pointBasicData, isPoint, getPointBasicData },
  } = useStore();

  const { t } = useMyTranslations<PointTransFields>([pointTranslations.name]);

  const { id } = useParams();
  const navigate = useNavigate();

  const { isLoading, mutate } = useMutation(getPointBasicData, {
    mutationKey: 'getPointData',
    onError: () => navigate('points'),
  });

  useEffect(() => {
    id && mutate(id);
  }, [id]);

  const title = useMemo(() => {
    if (isPoint) {
      return `${t('title')} "${pointBasicData?.name || id}"`;
    }
    return t('addTitle');
  }, [pointBasicData, id, isPoint]);

  return (
    <main className={styles.page}>
      {/* <header className={styles.header}>
        <h2 className={styles.headerTitle}>
          {isPoint ? `${t('title')} "${pointBasicData?.name || id}"` : t('addTitle')}{' '}
        </h2>
      </header> */}
      <EntityTitle title={title} deletedDate={pointBasicData?.deletedDate} />
      <div className={styles.container}>{isLoading ? <AppLoader /> : <PointBasicForm />}</div>
    </main>
  );
});

export default Point;
